// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"_1l198E6Y5b","darkSwitch":"PfxJhEH41z","switch":"_3BzfmoHW8N","dark":"_3Rx-ddp9AH","sun":"_2szZh4vbpy","moon":"_1UMpurkPYn"};